import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PLAYROOM_REWARDS_SECTION_PAGE_KEY } from "../constants";
export default /*#__PURE__*/_defineProperty({}, PLAYROOM_REWARDS_SECTION_PAGE_KEY, {
  PRS_TAB_MARKETPLACE: 'Catálogo',
  PRS_TAB_HISTORY: 'Historial',
  PRS_STATUS_DELIVERED: 'Entregado',
  PRS_STATUS_REQUESTED: 'Solicitado',
  PRS_ORDER_NUMBER: 'Pedido n° {{order}}',
  PRS_CTA_REWARD_TITLE: 'Seleccionaste este item',
  PRS_CTA_REWARD_CANCEL: 'Cancelar',
  PRS_CTA_REWARD_SOLICIT: 'Solicitar',
  PRS_SECTION_MARKETPLACE_DESCRIPTION: 'Descubre las recompensas que podrás canjear por tu esfuerzo realizado durante tus actividades de aprendizaje.',
  PRS_SECTION_MARKETPLACE_REDEEMING: 'Solicitando',
  PRS_X_CREHANACOINS: '{{coins}} {{currencyName}}',
  PRS_MISSING_CREHANACOINS: 'Te faltan *{{coins}} {{currencyName}}* para canjear esta recompensa',
  PRS_LIMIT_REMDEPTIONS_1: 'Te quedan',
  PRS_LIMIT_REMDEPTIONS_2: 'solicitudes disponibles para esta recompensa',
  PRS_WITHOUT_LIMITS: 'Puedes solicitar sin límites esta recompensa',
  PRS_LIMIT_REARCH_REDEMPTIONS: 'Llegaste al límite disponible de esta recompensa',
  PRS_ACCEPT_TERMS_1: 'Acepto los',
  PRS_ACCEPT_TERMS_2: 'términos y condiciones',
  PRS_EXCHANGE_SUCCESFUL_TITLE: '¡Solicitud de canje exitosa!',
  PRS_EXCHANGE_SUCCESFUL_DESCRIPTION: 'Tu administrador se contactará contigo para coordinar el recibimiento de tu recompensa.',
  PRS_EXCHANGE_SUCCESFUL_OK: 'Entendido',
  PRS_EXCHANGE_FAILED_TITLE: '¡Solicitud de canje fallida!',
  PRS_EXCHANGE_FAILED_DESCRIPTION: 'Ha ocurrido un error, por favor inténtelo de nuevo más tarde',
  PRS_EXCHANGE_FAILED_OK: 'Listo',
  PRS_CTA_EXCHANGE: 'Canjear',
  PRS_CTA_SEE_DETAIL: 'Ver detalle',
  PRS_HISTORY_SECTION_DESCRIPTION: 'Tu historial de compras',
  PRS_EMPTY_TITLE: 'Aún no has solicitado ninguna recompensa',
  PRS_EMPTY_DESCRIPTION: 'Dirígete al marketplace para elegir tu recompensa',
  PRS_EMPTY_MARKETPLACE_TITLE: 'No hay recompensas disponibles en este momento',
  PRS_AVAILABLE_COINS: 'Si canjeas estos puntos te quedarán',
  PRS_AVAILABLE_STOCK: '¡Queda {{count}} item!',
  PRS_AVAILABLE_STOCK_plural: '¡Quedan {{count}} items!'
});